import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import HeaderAfter from '../parts/Header'
import HeaderBefore from '../../pre_login/parts/Header'
import Footer from '../parts/Footer'
import ApiSubHeader from '../parts/ApiSubHeader'
import * as MyAPI from '../../../utils/MyAPI'
import * as AbstructedApi from '../../../utils/AbstructedApi'
import * as UserActions from '../../../actions/UserActions'
import SyntaxHighlighter from 'react-syntax-highlighter';
import { a11yDark } from 'react-syntax-highlighter/dist/esm/styles/hljs'
import DocsSideBar from './DocsSideBar'
import { Helmet } from "react-helmet";

// example of auth
let code_auth = [
  "curl --request POST \\ ",
  "  --url https://asr1.shabelab.com/transcribe \\ ",
  "  --header 'authorization: <APIのキー>'",
]
let code_auth_str = code_auth.join("\n")

// DocsReference
const DocsReference = (props) => {

  let dispatch = useDispatch();

  let navigate = useNavigate();
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });

  let [loading, setLoading] = useState(false)
  // let [lang, setLang] = useState("node")
  // let [codeType1, setCodeType1] = useState(code1_node_str)
  // let [codeType2, setCodeType2] = useState(code2_node_str)


  // componentDidMount
  useEffect(() => {
    // _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  //
  // // _changeLangNode
  // let _changeLang = (_lang) => {
  //   setLang(_lang)
  //   if (_lang === "node") {
  //     setCodeType1(code1_node_str)
  //     setCodeType2(code2_node_str)
  //   } else if (_lang === "python") {
  //     setCodeType1(code1_python_str)
  //     setCodeType2(code2_python_str)
  //   } else if (_lang === "curl") {
  //     setCodeType1(code1_curl_str)
  //   }
  // }

  return (
    <div>

      <Helmet>
        <meta charSet="utf-8" />
        <title>喋ラボの音声認識エンジンクラウド | ドキュメント | レファレンス</title>
        <meta name="description" content="喋ラボの音声認識エンジンクラウドのドキュメントのAPIレファレンスページです。" />
      </Helmet>


      {login_token ? (
        <HeaderAfter />
      ) : (
        <HeaderBefore />
      )}

      {/* main */}
      <Container fluid style={{
        // marginTop: 40,
      }}>

        <Row style={{
          // marginTop: 20,
          marginBottom: 20,
        }}>

          {/* side bar */}
          <DocsSideBar/>

          <Col md="9" xs="12">

            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <h1 style={{
                  fontSize: 26,
                }}>
                  APIレファレンス
                </h1>
              </Col>
            </Row>

            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <h2 style={{
                  fontSize: 20,
                  fontWeight: 'bold',
                }}>
                  APIエンドポイント
                </h2>
              </Col>
            </Row>

            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <span style={{
                  fontSize: 20,
                }}>
                  ベースモデルのAPIエンドポイントのURLは以下の通りです。
                </span>
              </Col>
            </Row>
            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col style={{
                // backgroundColor: 'red',
              }}>
                <p style={{
                  fontSize: 20,
                  color: '#ffffff',
                  backgroundColor: '#111111',
                  width: '100%',
                  padding: 8,
                }}>
                  https://asr1.shabelab.com/transcribe
                </p>
              </Col>
            </Row>
            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <span style={{
                  fontSize: 20,
                }}>
                  カスタムモデルをご利用の場合は個別に専用のエンドポイントURLが発行されます。
                </span>
              </Col>
            </Row>

            {/* Authentication */}
            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <h2 style={{
                  fontSize: 20,
                  fontWeight: 'bold',
                }}>
                  認証
                </h2>
              </Col>
            </Row>

            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <SyntaxHighlighter language="javascript" style={a11yDark} wrapLines={true}>
                  {code_auth_str}
                </SyntaxHighlighter>
              </Col>
            </Row>

            {/* transcribe */}
            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <h2 style={{
                  fontSize: 20,
                  fontWeight: 'bold',
                }}>
                  /transcribe
                </h2>
              </Col>
            </Row>

            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                <span style={{
                  fontSize: 20,
                }}>
                  リクエストはJSON形式、POSTメソッドで行います。
                </span>
              </Col>
            </Row>

            <Row style={{
              marginTop: 20,
              backgroundColor: '#111111',
              marginLeft: 4,
              marginRight: 4,
              color: '#ffffff',
              padding: 8,
            }}>

              <Col md="2" xs="12">
                Param
              </Col>
              <Col md="3" xs="12">
                Example
              </Col>
              <Col md="6" xs="12">
                Info
              </Col>
              <Col md="1" xs="12">
                Required
              </Col>

            </Row>

            <div style={{
              backgroundColor: '#eeeeee',
            }}>
              <Row style={{
                marginTop: 20,
                marginBottom: 20,
                marginLeft: 4,
                marginRight: 4,
                padding: 8,
                borderBottomColor: '#cccccc',
                borderBottomStyle: 'solid',
                borderBottomWidth: 1,
              }}>
                <Col md="2" xs="12">
                  audio
                </Col>
                <Col md="3" xs="12">

                </Col>
                <Col md="6" xs="12">
                  音声データをbase64でエンコードされたString形式で直接送信することができます。audioとaudio_urlのいずれかは必須です。
                </Col>
                <Col md="1" xs="12">
                  Yes *1
                </Col>
              </Row>

              <Row style={{
                marginTop: 20,
                marginBottom: 20,
                marginLeft: 4,
                marginRight: 4,
                padding: 8,
                borderBottomColor: '#cccccc',
                borderBottomStyle: 'solid',
                borderBottomWidth: 1,
              }}>
                <Col md="2" xs="12">
                  audio_url
                </Col>
                <Col md="3" xs="12" style={{
                  wordBreak: "break-all",
                }}>
                  "https://shabelab.com/sample.mp3"
                </Col>
                <Col md="6" xs="12">
                  音声をURLで指定することができます。audio_urlかaudioのいずれかは必須です。
                </Col>
                <Col md="1" xs="12">
                  Yes *1
                </Col>
              </Row>

              <Row style={{
                marginTop: 20,
                marginBottom: 20,
                marginLeft: 4,
                marginRight: 4,
                padding: 8,
                borderBottomColor: '#cccccc',
                borderBottomStyle: 'solid',
                borderBottomWidth: 1,
              }}>
                <Col md="2" xs="12">
                  response_type
                </Col>
                <Col md="3" xs="12">
                  "v2"
                </Col>
                <Col md="6" xs="12">
                  レスポンス形式。現在Googleと類似のv2のみがサポートされています。デフォルトはv2です。
                </Col>
                <Col md="1" xs="12">
                  No
                </Col>
              </Row>

              <Row style={{
                marginTop: 20,
                marginBottom: 20,
                marginLeft: 4,
                marginRight: 4,
                padding: 8,
                borderBottomColor: '#cccccc',
                borderBottomStyle: 'solid',
                borderBottomWidth: 1,
              }}>
                <Col md="2" xs="12">
                  request_id
                </Col>
                <Col md="3" xs="12">
                  "d89sg9ei7z8m"
                </Col>
                <Col md="6" xs="12">
                  リクエスト毎のユニークなID。デフォルトは""です。
                </Col>
                <Col md="1" xs="12">
                  No
                </Col>
              </Row>


              <Row style={{
                marginTop: 20,
                marginBottom: 20,
                marginLeft: 4,
                marginRight: 4,
                padding: 8,
                borderBottomColor: '#cccccc',
                borderBottomStyle: 'solid',
                borderBottomWidth: 1,
              }}>
                <Col md="2" xs="12">
                  webhook_url
                </Col>
                <Col md="3" xs="12" style={{
                  wordBreak: "break-all",
                }}>
                  "https://shabelab.com/callback"
                </Col>
                <Col md="6" xs="12">
                  認識結果を指定のURLへPOSTします。デフォルトは""です。
                </Col>
                <Col md="1" xs="12">
                  No
                </Col>
              </Row>


              <Row style={{
                marginTop: 20,
                marginBottom: 20,
                marginLeft: 4,
                marginRight: 4,
                padding: 8,
                borderBottomColor: '#cccccc',
                borderBottomStyle: 'solid',
                borderBottomWidth: 1,
              }}>
                <Col md="2" xs="12">
                  filler_removal
                </Col>
                <Col md="3" xs="12">
                  true
                </Col>
                <Col md="6" xs="12">
                  「あの」や「えーと」などのフィラーを除去します。デフォルトはtureです。
                </Col>
                <Col md="1" xs="12">
                  No
                </Col>
              </Row>



              <Row style={{
                marginTop: 20,
                marginBottom: 20,
                marginLeft: 4,
                marginRight: 4,
                padding: 8,
                borderBottomColor: '#cccccc',
                borderBottomStyle: 'solid',
                borderBottomWidth: 1,
              }}>
                <Col md="2" xs="12">
                  stereo
                </Col>
                <Col md="3" xs="12">
                  false
                </Col>
                <Col md="6" xs="12">
                  ステレオ音声を想定し、2つの結果を返します。デフォルトはfalseです。
                </Col>
                <Col md="1" xs="12">
                  No
                </Col>
              </Row>

              <Row style={{
                marginTop: 20,
                marginBottom: 20,
                marginLeft: 4,
                marginRight: 4,
                padding: 8,
                borderBottomColor: '#cccccc',
                borderBottomStyle: 'solid',
                borderBottomWidth: 1,
              }}>
                <Col md="2" xs="12">
                  get_timestamps
                </Col>
                <Col md="3" xs="12">
                  false
                </Col>
                <Col md="6" xs="12">
                  単語毎のタイムスタンプを返します。デフォルトはfalseです。将来レスポンス形式v3が実装された際にサポートされなくなる可能性があります。
                </Col>
                <Col md="1" xs="12">
                  No
                </Col>
              </Row>

              {/* remove spaces */}
              <Row style={{
                marginTop: 20,
                marginBottom: 20,
                marginLeft: 4,
                marginRight: 4,
                padding: 8,
                borderBottomColor: '#cccccc',
                borderBottomStyle: 'solid',
                borderBottomWidth: 1,
              }}>
                <Col md="2" xs="12">
                  remove_spaces
                </Col>
                <Col md="3" xs="12">

                </Col>
                <Col md="6" xs="12">
                  スペースを除きます
                </Col>
                <Col md="1" xs="12">
                  True
                </Col>
              </Row>

              {/* refactoring */}
              <Row style={{
                marginTop: 20,
                marginBottom: 20,
                marginLeft: 4,
                marginRight: 4,
                padding: 8,
                borderBottomColor: '#cccccc',
                borderBottomStyle: 'solid',
                borderBottomWidth: 1,
              }}>
                <Col md="2" xs="12">
                  refactoring
                </Col>
                <Col md="3" xs="12">

                </Col>
                <Col md="6" xs="12">
                  句読点で整形します
                </Col>
                <Col md="1" xs="12">
                  True
                </Col>
              </Row>

              {/* funnel dictionary */}
              <Row style={{
                marginTop: 20,
                marginBottom: 20,
                marginLeft: 4,
                marginRight: 4,
                padding: 8,
              }}>
                <Col md="2" xs="12">
                  mini_dictionary
                </Col>
                <Col md="3" xs="12">

                </Col>
                <Col md="6" xs="12">
                  認識率を上げたい特定の単語を登録することができます。*2
                </Col>
                <Col md="1" xs="12">
                  No
                </Col>
              </Row>


            </div>


            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                *1 リクエストにはbase64エンコードされた音声データの文字列か音声データのURLを指定する必要があります。両方指定する必要はありません。
              </Col>
            </Row>
            <Row style={{
              marginTop: 20,
              marginBottom: 20,
            }}>
              <Col>
                *2 辞書登録機能の詳細に関しましては<Link to="/docs_mini_dict" style={{
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  color: '#000000',
                }}>こちら</Link>を参照して頂けますでしょうか。
              </Col>
            </Row>

          </Col>

          <Col md="1" xs="12"/>
        </Row>

      </Container>

      <br/>

      {/* footer */}
      <Footer />

    </div>
  )
}

export default DocsReference
